import React, { Fragment, useState } from "react"
import { SettingsFormLayout } from "./SettingsFormLayout"
import { deleteAccount } from "../../../config/apisauce";
import { usePage } from "@inertiajs/react";
import useStore from "../../../states/store";
import { useLogoutUser } from "../../../components/generic/functions/genericFunctions";
import useNotiStack from "../../../hooks/useNotiStack";
import { DeleteAccountDialog } from "../DeleteAccountDialog";

export const SettingsDeleteAccount = () => {

  const handleLogout = useLogoutUser();
  const { success } = useNotiStack();
  const [{ loaderState }, { openLoader, closeLoader }] = useStore();
  const { auth } = usePage().props;
  const [openDeleteAccountConfirmationDialog, setOpenDeleteAccountConfirmationDialog] = useState(false);

  const handleDeleteAccount = async () => {
    openLoader();
    const response = await deleteAccount({ id: auth?.user?.id });
    if (response.ok) {
      success('You have deleted your account!');
      handleLogout();
    }
    closeLoader();
  };

  return (
    <Fragment>
      <SettingsFormLayout
        title={'Delete Account'}
        subTitle={'Deleting your Collab Creator Account will remove all your data and cannot be undone.'}
        buttonText={'Delete Account'}
        buttonVariant='outlined'
        buttonColor='error'
        action={() => setOpenDeleteAccountConfirmationDialog(true)}
        disabled={loaderState}
      />
      <DeleteAccountDialog
        openDeleteAccountConfirmationDialog={openDeleteAccountConfirmationDialog}
        setOpenDeleteAccountConfirmationDialog={setOpenDeleteAccountConfirmationDialog}
        handleDeleteAccount={() => handleDeleteAccount()}
      />
    </Fragment>
  )
};